/* eslint-disable no-nested-ternary */
import Dashboard from 'containers/Dashboard';
import i18n from 'i18n';
import { authenticateLogout } from 'modules/authenticate/actions';
import { modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import ApplicationState from 'store/interfaces';

interface OwnProps {
  modalOpen: (props: ModalFields) => void;
  authenticateLogout: () => void;
  permission?: string | string[];
}

const hasPermission = (
  permission: string | string[] | undefined,
  permissions: Record<string, boolean> | undefined
): boolean => {
  if (!permission || (Array.isArray(permission) && permission.length === 0))
    return true;
  if (!permissions) return false;
  if (Array.isArray(permission)) {
    return permission.some(p => !!permissions[p]);
  }
  return !!permissions[permission];
};

const PrivateRoute = ({
  component: Component,
  modalOpen,
  user,
  permission,
  noTemplate,
  authenticateLogout,
  ...rest
}) => {
  React.useEffect(() => {
    if (rest?.expiredSession === true) {
      modalOpen({
        title: i18n.t('EXPIRED_SESSION_MODAL.HEADER'),
        content: i18n.t('EXPIRED_SESSION_MODAL.MESSAGE'),
        action: <></>,
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        genericFooter: {
          action: () => {
            authenticateLogout();
          },
          label: 'Ok',
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest?.expiredSession]);

  return (
    <Route
      {...rest}
      render={({ location }) => {
        const renderComponent = !!user?.token;

        if (!renderComponent)
          return <Redirect to={{ pathname: '/', state: { from: location } }} />;

        const allowed = hasPermission(permission, user.permissions);

        return (
          <React.Fragment>
            {noTemplate ? (
              <Component {...rest} />
            ) : !allowed ? (
              <Dashboard component={<Redirect to={'/notPermission'} />} />
            ) : (
              <Dashboard component={<Component {...rest} />} />
            )}
          </React.Fragment>
        );
      }}
    />
  );
};

const mapStateToProps = ({
  authenticate: { data, expiredSession },
}: ApplicationState) => ({
  user: {
    token: data?.token,
    role: data?.role,
    permissions: data?.permissions,
  },
  expiredSession,
});

export default connect(mapStateToProps, {
  modalOpen,
  authenticateLogout,
})(PrivateRoute);
